import React from "react";
const CheckoutIcons = () => (
  <svg style={{ display: "none" }} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id="shieldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F5B041" />
        <stop offset="100%" stopColor="#E59C2E" />
      </linearGradient>
    </defs>

    <symbol id="icon-shield" viewBox="0 -1 36 40">
      <path
        d="M18 2L4 8v10c0 9.1 5.9 17.1 14 20 8.1-2.9 14-10.9 14-20V8L18 2z"
        fill="url(#shieldGrad)"
        opacity=".15"
      />
      <path
        d="M18 2L4 8v10c0 9.1 5.9 17.1 14 20 8.1-2.9 14-10.9 14-20V8L18 2z"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M13 18l3.5 3.5L23.5 14"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-lock" viewBox="0 0 24 24">
      <rect
        x="3"
        y="11"
        width="18"
        height="11"
        rx="2"
        ry="2"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M7 11V7a5 5 0 0 1 10 0v4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </symbol>

    <symbol id="icon-star" viewBox="0 0 24 24">
      <polygon
        points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
        fill="#F5B041"
        stroke="#C4841D"
        strokeWidth="1.5"
      />
    </symbol>

    <symbol id="icon-gift" viewBox="0 0 36 36">
      <rect
        x="5"
        y="18"
        width="26"
        height="14"
        rx="2"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <rect
        x="3"
        y="12"
        width="30"
        height="7"
        rx="2"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <line
        x1="18"
        y1="12"
        x2="18"
        y2="32"
        stroke="#C4841D"
        strokeWidth="2.5"
      />
      <ellipse
        cx="14"
        cy="9"
        rx="4.5"
        ry="3.5"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
      />
      <ellipse
        cx="22"
        cy="9"
        rx="4.5"
        ry="3.5"
        fill="none"
        stroke="#C4841D"
        strokeWidth="3"
      />
      <circle cx="18" cy="10" r="2.5" fill="#C4841D" />
    </symbol>

    <symbol id="icon-invoice" viewBox="0 0 36 38">
      <rect
        x="6"
        y="8"
        width="24"
        height="26"
        rx="1.5"
        fill="#F5B041"
        fillOpacity=".12"
        stroke="#C4841D"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <rect
        x="6"
        y="8"
        width="24"
        height="5"
        rx="1.5"
        fill="#C4841D"
        fillOpacity=".35"
      />
      <rect x="11" y="16" width="4" height="3.5" rx=".75" fill="#C4841D" />
      <rect x="21" y="16" width="4" height="3.5" rx=".75" fill="#C4841D" />
      <rect x="11" y="22" width="4" height="3.5" rx=".75" fill="#C4841D" />
      <rect x="21" y="22" width="4" height="3.5" rx=".75" fill="#C4841D" />
      <rect
        x="15"
        y="28"
        width="6"
        height="6"
        rx="1"
        fill="#C4841D"
        fillOpacity=".8"
      />
    </symbol>

    <symbol id="icon-infinity" viewBox="0 0 24 24">
      <path
        d="M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.74-8-4.585 0-4.585 8 0 8 5.607 0 7.645-8 12.74-8z"
        fill="#F5B041"
        fillOpacity=".18"
      />
      <path
        d="M18.178 8c5.096 0 5.096 8 0 8-5.095 0-7.133-8-12.74-8-4.585 0-4.585 8 0 8 5.607 0 7.645-8 12.74-8z"
        fill="none"
        stroke="#C4841D"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </symbol>

    <symbol id="icon-champagne" viewBox="0 0 24 24">
      <path
        d="M8.5 3 L15.5 3 L14.5 10.5 C14.5 12 13.3 13 12 13 C10.7 13 9.5 12 9.5 10.5 Z"
        fill="#F5B041"
        fillOpacity=".15"
        stroke="#C4841D"
        strokeWidth="1.5"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="13"
        x2="12"
        y2="20"
        stroke="#C4841D"
        strokeWidth="1.5"
      />
      <line
        x1="9"
        y1="20.5"
        x2="15"
        y2="20.5"
        stroke="#C4841D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="11" cy="6" r="0.6" fill="#C4841D" />
      <circle cx="13" cy="5" r="0.5" fill="#C4841D" />
      <circle cx="12" cy="8" r="0.5" fill="#C4841D" />
      <circle cx="13.5" cy="2.5" r="0.4" fill="#C4841D" opacity="0.6" />
      <circle cx="10.5" cy="2" r="0.3" fill="#C4841D" opacity="0.5" />
    </symbol>
  </svg>
);

export default CheckoutIcons;
